/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const levelUp = (
	<SVG fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="m13.53 8.47-1.06 1.06-2.72-2.72V12h-1.5V6.81L5.53 9.53 4.47 8.47 9 3.94l4.53 4.53Zm-1.802 7.968c1.307.697 3.235.812 5.772.812v1.5c-2.463 0-4.785-.085-6.478-.988a4.721 4.721 0 0 1-2.07-2.13C8.48 14.67 8.25 13.471 8.25 12h1.5c0 1.328.208 2.28.548 2.969.332.675.81 1.138 1.43 1.47Z" />
	</SVG>
);

export default levelUp;
